export default __webpack_public_path__ + "static/media/effect3.26dec815.wav";